var inPopDetailPage = false;
try {
    inPopDetailPage =
        window.parent &&
        window.parent !== window &&
        !!window.parent.__curDetailPop;
} catch (e) {}

export default inPopDetailPage;
